module.exports = __webpack_public_path__ + "media/images/ic-marker-fccd8a09.svg";